import {
  User,
  TableDocument,
  DollarSquare,
  Autobrightness,
  Signpost,
  SmsNotification,
  Element4,
  DocumentText,
} from "iconsax-react";

const ADMIN = (t) => {
  return [
    {
      label: t("menu.order"),
      path: "/app/order",
      name: `order`,
      icon: <SmsNotification size="25" />,
    },
    {
      label: t("menu.sign"),
      path: "/app/sign",
      name: `sign`,
      icon: <Signpost size="25" />,
    },
    {
      label: t("menu.consts"),
      path: "/app/consts",
      name: `consts`,
      icon: <Autobrightness size="25" />,
    },
    {
      label: t("menu.type"),
      path: "/app/type",
      name: `type`,
      icon: <Element4 size="25" />,
    },
    {
      label: t("menu.price"),
      path: "/app/price",
      name: `price`,
      icon: <DollarSquare size="25" />,
    },
    {
      label: t("menu.advice"),
      path: "/app/advice",
      name: `user`,
      icon: <DocumentText size={25} />,
    },
    {
      label: t("menu.user"),
      path: "/app/user",
      name: `user`,
      icon: <User size={25} />,
    },

    {
      label: t("menu.log"),
      path: "/app/log",
      name: `log`,
      icon: <TableDocument size={25} />,
    },
  ];
};
const USER = (t) => {
  return [
    {
      label: t("menu.order"),
      path: "/app/order",
      name: `order`,
      icon: <SmsNotification size="25" />,
    },
  ];
};
const MENU = (t, type) => {
  if (type == "admin") return ADMIN(t);
  else return USER(t);
};
export default MENU;
